export const FILE_BLOCK_COLOR = {
  YELLOW: 'yellow',
  GREEN: 'green',
  RED: 'red',
  GRAY: 'gray',
};

export const FILE_BLOCK_COLORS = Object.values(FILE_BLOCK_COLOR);
